import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Icon from '../../Icons';
import LinkBtn from '../../Utils/Button/LinkBtn';

const MyDocuments = () => {
  return (
    <>
      <div
        id="HRDashboard"
        style={{
          backgroundColor: '#fff',
          border: '1px solid #E0E0E0',
          borderRadius: '8px',
          height: '100%',
          minHeight: '121px'
        }}
      >
        <div
          style={{
            textAlign: 'center',
            backgroundColor: '#fff',
            borderTopRightRadius: 8,
            borderTopLeftRadius: 8
          }}
        >
          <Row>
            <Col className="mt-2" md={8} xl={8} xs={8}>
              <p
                style={{
                  fontSize: '12px',
                  fontWeight: 'bold',
                  color: '#827f7f',
                  textAlign: 'left',
                  marginLeft: '10px'
                }}
              >
                Mis Documentos
              </p>
            </Col>
          </Row>
        </div>

        <div style={{ paddingRight: 15, paddingLeft: 15 }}>
          <Row className="align-items-center">
            <Col sm={4} xs={12} md={4} className="mb-2 text-center">
              <LinkBtn
                size="sm"
                to="documents"
                block
                style={{ textTransform: 'capitalize', fontSize: '10px' }}
                className="d-flex flex-column justify-content-center align-items-center"
              >
                <Icon icon="document" className="icon-30" />
                Contrato
              </LinkBtn>
            </Col>
            <Col sm={4} xs={12} md={4} className="mb-2 text-center">
              <LinkBtn
                to="documents"
                block
                className="d-flex flex-column justify-content-center align-items-center"
                style={{ textTransform: 'capitalize', fontSize: '10px' }}
              >
                <Icon icon="document-attach" className="icon-30" />
                Anexo
              </LinkBtn>
            </Col>
            <Col sm={4} xs={12} md={4} className="mb-2 text-center">
              <LinkBtn
                to="documents"
                block
                className="d-flex flex-column justify-content-center align-items-center"
                style={{ textTransform: 'capitalize', fontSize: '10px' }}
              >
                <Icon icon="school" className="icon-30" />
                Certificados
              </LinkBtn>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default MyDocuments;
